// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/LastChange/LastChange.css */

.last-changes-container {
    overflow-y: auto;
    height: 70vh;
    background-color: #EF6F53;
    margin: auto;
    max-width: 100%;
    text-align: left;
    position: relative; 
}

.last-headi {
    color: #364C63;
    text-align: center;
    font-size: 1rem;
    font-weight: 900;
    letter-spacing: 0.05rem;
    margin-bottom: 1rem;
    margin-top: 0.5rem;
}

.changes-content{
    font-size: 0.8em;
    margin: 1rem;
    color: white;

}

.change-message{
    font-weight: 600;

}


/* Responsive styles for screens between 901px and 1280px */
@media only screen and (min-width: 901px) and (max-width: 1280px) {
    .last-changes-container {
        height: 75vh;
    }
}

/* Responsive styles for screens between 1281px and 1400px */
@media only screen and (min-width: 1281px) and (max-width: 1400px) {
    .last-changes-container {
        height: 75vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/LastChange/LastChange.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;;AAEpB;;;AAGA,2DAA2D;AAC3D;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,4DAA4D;AAC5D;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* src/components/routes/Forms/LastChange/LastChange.css */\n\n.last-changes-container {\n    overflow-y: auto;\n    height: 70vh;\n    background-color: #EF6F53;\n    margin: auto;\n    max-width: 100%;\n    text-align: left;\n    position: relative; \n}\n\n.last-headi {\n    color: #364C63;\n    text-align: center;\n    font-size: 1rem;\n    font-weight: 900;\n    letter-spacing: 0.05rem;\n    margin-bottom: 1rem;\n    margin-top: 0.5rem;\n}\n\n.changes-content{\n    font-size: 0.8em;\n    margin: 1rem;\n    color: white;\n\n}\n\n.change-message{\n    font-weight: 600;\n\n}\n\n\n/* Responsive styles for screens between 901px and 1280px */\n@media only screen and (min-width: 901px) and (max-width: 1280px) {\n    .last-changes-container {\n        height: 75vh;\n    }\n}\n\n/* Responsive styles for screens between 1281px and 1400px */\n@media only screen and (min-width: 1281px) and (max-width: 1400px) {\n    .last-changes-container {\n        height: 75vh;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
